<div class="modal-header">
  <h5 class="modal-title">
    <i class="far fa-image"></i>&nbsp;&nbsp;<ng-container i18n>Insert / edit image</ng-container>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <ng-container *rerender="resetCounter">
    <div class="upload-box-container">
      <app-upload-box
        [options]="uploadOptions"
        [showFileList]="false"
        image="/assets/images/upload-formate.png"
        (complete)="onUploaded($event)"
      >
      </app-upload-box>

      <div class="image-preview bg-default2" *ngIf="!form.get('src').invalid">
        <img [src]="form.get('src').value" />
      </div>
    </div>
  </ng-container>

  <form [formGroup]="form" class="mt-4">
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field2>
          <input type="text" matInput required i18n-placeholder placeholder="Image Source" formControlName="src" />
          <mat-error *ngIf="form.get('src').touched && form.get('src').hasError('required')" i18n>
            Image source is required
          </mat-error>
          <mat-error *ngIf="form.get('src').touched && form.get('src').hasError('url')" i18n>
            Image source is invalid
          </mat-error>
        </mat-form-field2>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field2>
          <input
            type="text"
            matInput
            i18n-placeholder
            placeholder="Image Description"
            formControlName="alt"
            maxlength="500"
          />
        </mat-form-field2>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field2>
          <input type="number" formControlName="width" matInput i18n-placeholder placeholder="Width" min="0" />
          <mat-error *ngIf="form.get('width').touched && form.get('width').hasError('min')">
            <ng-container i18n>Value need to be at least 0</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('width').touched && form.get('width').hasError('integer')" i18n>
            Value need to be integer
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-4">
        <mat-form-field2>
          <input type="number" formControlName="height" matInput i18n-placeholder placeholder="Height" min="0" />
          <mat-error *ngIf="form.get('height').touched && form.get('height').hasError('min')">
            <ng-container i18n>Value need to be at least 0</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('height').touched && form.get('height').hasError('integer')" i18n>
            Value need to be integer
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-4">
        <button
          (click)="toggleLock(); $event.currentTarget.blur()"
          class="btn btn-lock {{ isLock ? 'btn-secondary-danger' : 'btn-secondary-info' }}"
          i18n-matTooltip
          matTooltip="Unlock/Lock Proportions"
          matTooltipPosition="below"
        >
          <i *ngIf="isLock" class="far fa-lock"></i>
          <i *ngIf="!isLock" class="far fa-unlock"></i>
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button *ngIf="isEdit" (click)="onRemove()" type="button" class="btn btn-secondary-danger">
    <i class="far fa-times"></i> <ng-container i18n>Remove</ng-container>
  </button>

  <div class="flex-1"></div>

  <button (click)="onClose()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>

  <button (click)="onSubmit(form)" type="button" class="btn btn-secondary-info create-btn">
    <span class="cs-icon cs-icon-save"></span> <ng-container i18n>Save</ng-container>
  </button>
</div>
